import { PATHS } from './constants';
import { Task } from './customTypes';
import type { History } from 'history';

export const getTaskRoute = (task: Task) => {
  return `/project/${task.project_id}/tasks/${task.id}`;
};

export type RequestListRouteContext = {
  isJsonSchema?: boolean;
};

export const getRequestRoute = (
  requestId: string,
  organizationId?: string | null,
  request?: RequestListRouteContext
): string => {
  if (request?.isJsonSchema) {
    return `${PATHS.REQUEST_PAGE_V2}/${requestId}`;
  }

  if (organizationId) {
    return `${PATHS.REQUEST_PAGE}/${requestId}?accountId=${organizationId}`;
  }

  return `${PATHS.REQUEST_PAGE}/${requestId}`;
};

export const navigateToRequest = (
  history: History,
  href: string,
  isJsonSchema?: boolean,
  state?: unknown
) => {
  if (!href) {
    // eslint-disable-next-line no-console
    console.error(
      '[navigateToRequest] called with empty href — navigation aborted.'
    );
    return;
  }

  if (isJsonSchema) {
    window.location.assign(href);
    return;
  }

  history.push(href, state);
};
